import { computed, inject, Injectable, Signal } from '@angular/core';
import { WebTextStore } from '../../api/text/web-text-store.service';
import { FilterTextsPipe } from '../../../pipes/filterTexts/filterTexts.pipe';
import { LanguagePipe } from '../../../pipes/language/language.pipe';
import {
  DATE_FORMAT,
  EEntityType,
  ERelationType,
  TIME_FORMAT_SHORT,
} from '@web/dtos';

@Injectable({
  providedIn: 'root',
})
export class DateFormatSupport {
  private readonly textStore: WebTextStore = inject(WebTextStore);
  private readonly filterTextsPipe: FilterTextsPipe = inject(FilterTextsPipe);
  private readonly languagePipe: LanguagePipe = inject(LanguagePipe);

  public readonly activeDateFormat: Signal<string> = computed(() => {
    return (
      this.languagePipe.transform(
        this.filterTextsPipe.transform(
          this.textStore.texts(),
          ERelationType.dateFormat,
          EEntityType.generic
        )
      ) || DATE_FORMAT
    );
  });

  public readonly activeTimeFormat: Signal<string> = computed(() => {
    return (
      this.languagePipe.transform(
        this.filterTextsPipe.transform(
          this.textStore.texts(),
          ERelationType.timeFormat,
          EEntityType.generic
        )
      ) || TIME_FORMAT_SHORT
    );
  });
}
